// import Vue from 'vue'
// import VueAMap from 'vue-amap'
//
// Vue.use(VueAMap)
// VueAMap.initAMapApiLoader({
//   key:'d26b5af3f48ce10f12ffc1040cf894bb',
//   // 'AMap.Geolocation','AMap.Geocoder'
//   // plugin:['AMap.CitySearch','AMap.Geocoder','AMap.Geolocation'],
//   plugin:["AMap.Geocoder"],
//   version:'2.0'
// })